import {
  Component,
  OnInit,
  Renderer2,
  ElementRef,
  inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RentalService } from '../../services/rental.service';
import { Rental } from '../../models/rental.model';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';

declare var bootstrap: any;

@Component({
  selector: 'app-apply-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './apply-detail.component.html',
  styleUrls: ['./apply-detail.component.scss']
})
export class ApplyDetailComponent implements OnInit {
  rental$!: Observable<Rental | null>;
  loading = true;
  redirecting = false;
  selectedImageIndex = 0;
  carouselInstance: any;

  private renderer = inject(Renderer2);
  private el = inject(ElementRef);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rentalService: RentalService
  ) {}

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (!id) {
      this.router.navigate(['/apply']);
      return;
    }

    this.rental$ = this.rentalService.getRentalById(id);
    this.loading = false;

    // Initialize carousel after view loads
    setTimeout(() => {
      const el = document.getElementById('rentalCarousel');
      if (el) this.carouselInstance = new bootstrap.Carousel(el);
    }, 0);
  }

  selectImage(index: number) {
    this.selectedImageIndex = index;
    this.goToSlide(index);
  }

  goToSlide(index: number) {
    if (this.carouselInstance) {
      this.carouselInstance.to(index);
    }
  }

  goToApplication() {
    this.redirecting = true;

    // Smooth scroll to top before route change
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Fade-out animation
    this.renderer.addClass(this.el.nativeElement, 'fade-out');

    setTimeout(() => {
      this.router.navigate(['/application-submission', this.route.snapshot.paramMap.get('id')]);
    }, 400);
  }
}
